import React from 'react';
import styles from './Section4.module.scss';
import FAQPoint from './FAQPoint';
import { FAQ_DATA } from './FAQData';

const Section4 = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.heading}`}>FAQs</div>
        <div className={`${styles.faqContainer}`}>
          {FAQ_DATA.map((item, index) => {
            return (
              <div key={index + Math.random()}>
                <FAQPoint data={item} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Section4;
